'use strict';


const greetings = (name) => {
    return `hello ${name}`;
}



$(document).ready(function(){

    // Footer Stats counter

    var homesElement = document.querySelector("#homesCountId");
    var contractorElement = document.querySelector("#contractorCountId");
    var carbonElement = document.querySelector("#carbonCountId");

    var possibleCountUpElements = [ homesElement, contractorElement, carbonElement ];
    var countUpElements = possibleCountUpElements.filter(el => el !== null);

    var isMobile = false;
    function countUpElement(id){
        var elemId = "#" + id;
        var element = document.querySelector(elemId); 
        var number = element.innerHTML;
        number = Math.round(parseInt(number.replace(/,/g, ""), 10));
        var startVal = number > 100 ? number / 8 : 0; 
        var duration = 3;
        if (id === "#contractorCountId"){ duration = 4; }
        if (id === "#carbonCountId"){ duration = 5; }
        var options = {
            startVal : startVal,
            duration : duration,
            smartEasingThreshold : number
        };
        var el = new countUp.CountUp(id, number, options);
        el.start();
    }

    if (countUpElements.length > 0){

        var hasRun = false;

        function runCountUp(){
            if (!hasRun){
                if (homesElement){
                    countUpElement("homesCountId");
                } 
                if (contractorElement){
                    countUpElement("contractorCountId");
                } 
                if (carbonElement){
                    countUpElement("carbonCountId");
                } 
            }
        }
        
        function isInView(elem) {
            var docViewTop = $(window).scrollTop();
            // var docViewBottom = docViewTop + $(window).height();
            var docViewBottom = docViewTop + window.innerHeight;
            var elemTop = $(elem).offset().top;
            return ((elemTop <= docViewBottom - 40) && (elemTop >= docViewTop));
        }

        var checkElement = '#' + countUpElements[0].id;
    
        $(window).scroll(function(){
            if(isInView(checkElement)) {
                runCountUp();
                hasRun = true;
            }
        });
    
        if(isInView(checkElement)) {
            runCountUp();
            hasRun = true;
        } //check once for if it starts in view
    }




    function checkIfMobile(){
        if ($(window).width() < 1024) {
            isMobile = true;
        } else {
            isMobile = false;
        }
    }
    checkIfMobile();

    $(window).on('resize', _.debounce(function() {
        checkIfMobile();
    }, 500));

    // Open mobile nav menu by default
    if ($(window).width() < 1024){
        var $activeNavItem = $('.main-nav ul.level-1 > li.active');
        $activeNavItem.addClass('open');
        $activeNavItem.find('.main-nav-mega-menu').stop().fadeIn(200).css('transform','translateY(0)').css('display','flex');
    }


    $('body').addClass('page-ready');

    $('.js-toggle-mobile-nav').click(function(){
        if ($('body').hasClass('is-showing-mobile-nav')){
        closeMobileNav();
        } else {
        openMobileNav();
        }
    });


    function openMobileNav(){
        $('body').addClass('is-showing-mobile-nav');
    }

    function closeMobileNav(){
        $('body').removeClass('is-showing-mobile-nav');
    }


    const animateRows = document.querySelectorAll('.js-view-check');




     var scrollThrottleTimeout;
            $(window).bind(
                'scroll',
                function()
                {
                    if (!scrollThrottleTimeout) {
                        scrollThrottleTimeout = setTimeout(
                            function()
                            {
                                //  console.log('test');
                                onPageScroll();
                                scrollThrottleTimeout = null;
                            },
                            100
                        );
                    }
                }
            );

            var prevScrollpos = window.pageYOffset;

            function onPageScroll(){
                // console.log("Scrolled");
                if ($(window).scrollTop() >= 30) {
                    $('.header').addClass('is-compressed');
                } else {
                    $('.header').removeClass('is-compressed');
                }



                // window.onscroll = function() {
                //     var currentScrollPos = window.pageYOffset;
                //     if (prevScrollpos > currentScrollPos) {
                //         $('.header').removeClass('hide');
                //     } else if (currentScrollPos > 200) {
                //         $('.header').addClass('hide');
                //     }
                //     prevScrollpos = currentScrollPos;
                // }

            }

onPageScroll();




    $(".js-scroll-to").click(function (){
    	var scrollTarget = $(this).attr('scroll-to');
        $('html, body').animate({
            scrollTop: $('.'+scrollTarget).offset().top - 100
        }, 800);
    });


    // Acccessible nav dropdowns    

    var menuItems = document.querySelectorAll('ul.level-1 > li.has-children, ul.level-0 > li.has-children.top-nav__site-tool');
    
 
    Array.prototype.forEach.call(menuItems, function(el, i){
        var activatingA = el.querySelector('a');
        var btn = '<button class="main-nav__chevron"><span class="visually-hidden">Show submenu for "' + activatingA.text + '"</span></button>';
        activatingA.insertAdjacentHTML('afterend', btn);

        el.querySelector('button').addEventListener("click",  function(event){
            // console.log(this.parentNode);
            if ($(this).parent().hasClass('open')){
                $(this).next().fadeOut(200);
                $(this).parent().removeClass('open');
                this.parentNode.querySelector('a').setAttribute('aria-expanded', "false");
                this.parentNode.querySelector('button').setAttribute('aria-expanded', "false");
            } else {
                $(this).next().fadeIn(200).css('display','flex');
                $(this).parent().addClass('open');
                this.parentNode.querySelector('a').setAttribute('aria-expanded', "true");
                this.parentNode.querySelector('button').setAttribute('aria-expanded', "true");

            }
            event.preventDefault();
        });


    });

    var opts = {
        sensitivity: 25,
        interval: 100
    };



    if(!isMobile){
        var _hoverTriggers = document.querySelectorAll('.main-nav ul.level-1 > li.has-children');
        Array.prototype.forEach.call(_hoverTriggers, function(el) {
            hoverintent(el, mainNavHoverIn, mainNavHoverOut).options(opts);
        });
    }


    $('.main-nav ul.level-1 > li.has-children').hover(function(){
        $('body').addClass('is-showing-meganav-early');
    }, function(){
        $('body').removeClass('is-showing-meganav-early');
    });


    function mainNavHoverIn(){
        $(this).addClass('open');
        $(this).find('.main-nav-mega-menu').stop().fadeIn(200).css('display','flex');
        $('body').addClass('is-showing-meganav');
    }

    function mainNavHoverOut(){
       $(this).removeClass('open');
       $(this).find('.main-nav-mega-menu').stop().delay(200).fadeOut(200);
       $('body').removeClass('is-showing-meganav');
    }


    $('.top-nav ul.level-1 > li').hover(function(){
        $(this).addClass('open');
        $(this).find('ul.level-2').stop().fadeIn(200).css('display','flex');
    }, function(){
        $(this).removeClass('open');
        $(this).find('ul.level-2').fadeOut(200);
    });


    // Opening secondary nav on hover
    $('ul.level-0 > li.has-children.top-nav__site-tool').hover(function(){
        $(this).addClass('open');
        $(this).find('ul.level-2').stop().fadeIn(200).css('transform','translateY(1.2rem)').css('display','flex');
    }, function(){
        $(this).removeClass('open');
        $(this).find('ul.level-2').fadeOut(200).css('transform','translateY(2rem)');
    });


    // =====================================


    // var carousel = new myCarousel();
    // carousel.init({
    //     id: 'carousel',
    //     slidenav: true,
    //     animate: true,
    //     startAnimated: true
    // });



    $('.accordion-row').click(function(e){
        toggleAccordion($(this));
    });

    function toggleAccordion($accordion){
        // grab the aria-controls and the current status for aria-expanded
        var ariaControlsId = $accordion.attr('aria-controls');
        var ariaExpanded = $accordion.attr('aria-expanded');

        //close all accordions
        $('.accordion-row').attr("aria-expanded","false");
        $('.accordion-row__content').hide();

        // adjust aria-expanded depending if the accordion row has been clicked
        if(ariaExpanded == 'false') {
            $accordion.attr("aria-expanded","true");
            $accordion.next('.accordion-row__content').slideDown();
        } else {
            $accordion.attr("aria-expanded","false");
            $accordion.next('.accordion-row__content').slideUp();
        }
    }

    // Accordion JS for FAQ block rows
    $('.faq-row').click(function(e){
        toggleAccordion($(this));
    });

    function toggleAccordion($accordion){
        // grab the aria-controls and the current status for aria-expanded
        var ariaControlsId = $accordion.attr('aria-controls');
        var ariaExpanded = $accordion.attr('aria-expanded');

        //close all accordions
        $('.faq-row').attr("aria-expanded","false");
        $('.faq-row__content').hide();

        // adjust aria-expanded depending if the accordion row has been clicked
        if(ariaExpanded == 'false') {
            $accordion.attr("aria-expanded","true");
            $accordion.next('.faq-row__content').slideDown();
        } else {
            $accordion.attr("aria-expanded","false");
            $accordion.next('.faq-row__content').slideUp();
        }
    }



    $('.js-launch-solution-video').fancybox({
        media : {
            youtube : {
                url: "//www.youtube.com/embed/$4"
            }
        }
    });


    $(".js-scroll-to").click(function (){
        var scrollTarget = $(this).attr('scroll-to');
        $('html, body').animate({
            scrollTop: $('.'+scrollTarget).offset().top - 75
        }, 800);
    });



    //Checks on click targets. Closes certain menus dependant on target
    $(document).click(function(e) {
        e.stopPropagation();
        var target = e.target;

        if (!$(target).is('.js-open-search') && !$(target).parents().is('.js-open-search') && !$(target).is('.header__search-field') && !$(target).parents().is('.modal-dialog')) {
            closeSearch();
        }

    });
    


    // **************************************
    // Search Start

    $('.js-open-search').attr("data-toggle","modal");
    $('.js-open-search').attr("data-target","#search-modal");

    $('.js-open-search').click(function(e){
        e.preventDefault();
        openSearch();
    });

    $('.js-close-search').click(function(e){
        e.preventDefault();
        closeSearch();
    });

    function openSearch(){
        $('body').addClass('is-searching');
        $( "#search" ).focus();
    }

    function closeSearch(){
        $('body').removeClass('is-searching');
    }

    $(document).ajaxStart(function(){
        $('.ajax-loader').fadeIn();
    });
    $(document).ajaxComplete(function(){
        $('.ajax-loader').fadeOut();
    });
    $("#search").keyup(function(event) {
        if (event.keyCode === 13) {
            $("#submit-filters").click();
        }
    });

    $('#search').keyup(_.debounce(doSearch , 500));
    var historySupport = !!(window.history && history.pushState);

    function doSearch(){
        var search = $('#search').val();
        // console.log(search.length);
        if (search.length == 0){
            $('#query-container').fadeOut();
        } else {
            if($('#search')[0].checkValidity()){
                ajaxCall(search);
                // e.stopPropagation();
            }
            else{
                $.fancybox.open($("#search-error"));
            }
        }

    }


    function ajaxCall(search){
        $('.search-panel__loading').fadeIn();
        $('#query-container').fadeOut();
        // console.log("search : ", search);
        $.ajax('/hidden/search-ajax-request?&q='+search, {
            dataType : 'html',
            success : function (response) {
                $('.search-panel__loading').fadeOut();
                refreshResults(response, search);
                $('#query-container').fadeIn();
                if (historySupport) {
                    // Update the browser's address bar
                    history.pushState(null, null, '?search='+search.trim().replace(/\s+/g, '+'));
                }
            }
        });
    }
    function refreshResults (html, search)
    {
        var $html = $('<div />').append(html);
        // $.when($('#query-container').fadeOut(),$('#query-header').fadeOut(),$('#query-title').fadeOut()).then(function(){
        // $('#query-breadcrumbs').html($html.find('#query-breadcrumbs').html()).fadeIn();
        $('#query-container').html($html.find('.search-results-wrapper').html()).fadeIn();
        // $('#query-header').html($html.find('#query-header').html()).fadeIn();
        // $('#query-title').html($html.find('#query-title').html()).fadeIn();
        // })
        dataLayerSearch(search);

        const searchResultsScroller = document.querySelector('#search-results-scroller');
        const ps = new PerfectScrollbar(searchResultsScroller);
    }

    if(window.location.search.includes('search')) {
        var searchMade = true
    }
    if(searchMade) {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        var savedSearch = params.search;
        //re-open modal
        $('#search-modal').modal('show');

        $('#search').val(savedSearch);
        ajaxCall(savedSearch);
    }


    // Search End
    // **************************************

    // Update Mobile Audience Picker Dropdown

    $(".audience-picker__dropdown-menu button").click(function(){
        var activeSite = $(this).attr('active-site');
        var toggle = $(this).parents(".dropdown").find('.dropdown-toggle');
        toggle.attr('active-site', activeSite);
        toggle.find('i').attr('active-site', activeSite);
        toggle.find('span').html($(this).text());
        toggle.val($(this).data('value'));
    });



    // Social share widget code Start
    // **************************************
    if ($('.social-share-buttons').length > 0) {

        // Twitter
        $('.share-twitter').sharrre({
            share: {
                twitter: true
            },
            text: "{{title}}",
            enableHover: false,
            enableTracking: true,
            template: '<i class="i-share-x-twitter" id="share-social-twitter"></i>',
            buttons: { twitter: {}},
            click: function(api, options){
                api.simulateClick();
                api.openPopup('twitter');
            }
        });

        // Facebook
        $('.share-facebook').sharrre({
            share: {
                facebook: true
            },
            title: "{{title}}",
            text: "{{description}}",
            enableHover: false,
            enableTracking: false,
            enableCounter: false,
            template: '<i class="i-share-facebook" id="share-social-facebook"></i>',
            buttons: { facebook: {}},
            click: function(api, options){
                api.simulateClick();
                api.openPopup('facebook');
            }
        });


        $('.share-linkedin a').on("click", function(e) {
            $(this).customerPopup(e);
        });

    }


    /**
     * jQuery function to prevent default anchor event and take the href * and the title to make a share popup
     *
     * @param  {[object]} e           [Mouse event]
     * @param  {[integer]} intWidth   [Popup width defalut 500]
     * @param  {[integer]} intHeight  [Popup height defalut 400]
     * @param  {[boolean]} blnResize  [Is popup resizeabel default true]
     */
    $.fn.customerPopup = function (e, intWidth, intHeight, blnResize) {

        // Prevent default anchor event
        e.preventDefault();

        // Set values for window
        intWidth = intWidth || '500';
        intHeight = intHeight || '400';
        strResize = (blnResize ? 'yes' : 'no');

        // Set title and open popup with focus on it
        var strTitle = ((typeof this.attr('title') !== 'undefined') ? this.attr('title') : 'Social Share'),
            strParam = 'width=' + intWidth + ',height=' + intHeight + ',resizable=' + strResize,
            objWindow = window.open(this.attr('href'), strTitle, strParam).focus();
    }


    // Social share widget code End
    // **************************************


    // Contractor Checkbox Interactive Start
    // **************************************

    if($('.contractor-checkbox-interactive').length > 0){
        $('.contractor-checkbox-interactive .checker').change(function() {
            var numberOfCheckboxesSelected = $('.contractor-checkbox-interactive input[type=checkbox]:checked').length;
            //console.log(numberOfCheckboxesSelected);
            $('.contractor-checkbox-interactive__result').attr('aria-hidden', true);
            if(numberOfCheckboxesSelected > 0 && numberOfCheckboxesSelected <= 2){
                $('.contractor-checkbox-interactive__result[qualify=false]').attr('aria-hidden', false);
            } else if(numberOfCheckboxesSelected > 2){
                $('.contractor-checkbox-interactive__result[qualify=true]').attr('aria-hidden', false);
            }
        });
    }


    // Contractor Checkbox Interactive End
    // **************************************


    // Gallery Row Start
    // **************************************
    if($('.gallery-row__carousel').length > 0){
        $('.gallery-row__carousel').slick({
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow:4,
            responsive: [
                {
                    breakpoint: 600, // Phone Large
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
            ]
        });
    }
    // Gallery Row End
    // **************************************


    // DataLayer Functionality
    // ******************************************
    // FYI  Some datalayer work is baked into specific twig templates, such as forms and the selectedPearl Audience page push

    // Search Data Layer
    window.dataLayer = window.dataLayer || [];


    var stringToKebab = function(string){
        return string
          .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
          .replace(/([A-Z])([A-Z])(?=[a-z])/g, '$1-$2')
          .toLowerCase();
    };

    var getCookie = function(name) {
        var cookies = document.cookie.split(';');
        for(var i=0 ; i < cookies.length ; ++i) {
            var pair = cookies[i].trim().split('=');
            if(pair[0] == name)
                return pair[1];
        }
        return null;
    };

    // setTimeout(
    //     function()
    //     {
    //         if (getCookie('EX.PC') != null){
    //             var exactiuscookie = getCookie('EX.PC');
    //             if($("input[name='exactiuscookie']").val != 'none' || $("input[name='exactiuscookie']").val != ''){
    //                 $("input[name='exactiuscookie']").val(decodeURIComponent(exactiuscookie));
    //             }
    //         }
    //     },
    // 3000
    // );

    var selectedPearlAudience = stringToKebab(getCookie('selectedPearlAudience'));

    function dataLayerSearch(search){
        dataLayer.push({
          'event': 'searchTerm',
          'searchText': search,
          'audienceType': selectedPearlAudience,
          'linkClick': window.location.href
        });
    }

    function dataLayerSearchSelection(title, url){

        dataLayer.push({
          'event': 'searchTermSelection',
          'searchSelection': title,
          'searchSelectionURL': url,
          'audienceType': selectedPearlAudience,
          'linkClick': window.location.href
        });
    }

    function dataLayerVideClick(title){

        dataLayer.push({
          'event': 'youTubeClick',
          'youTubeTitle': title,
          'audienceType': selectedPearlAudience,
          'linkClick': window.location.href
        });

    }

    // Datalayer for Search Link click
    $('body').on('click', '.search-results a', function(){
        var title = $(this).find('.search-result__title').text();
        var url = $(this).attr('href');
        dataLayerSearchSelection(title, url);
    })


    // Datalayer for Video Clicks
    $('.video-block .video-block__image').click(function(){
        var title = $(this).attr('data-title');
        dataLayerVideClick(title);
    });

    // Datalayer Login link clicks
    $( "a:contains('Login')" ).click(function(){
        dataLayer.push({
          'event': 'loginNowSubmission',
          'linkClick': window.location.href
        });
    });
        // Form Submission Data layer Functionality        
        
        // Tracking Interested In Checkboxes
        var audienceTypeCheckbox = [];
        
        $('input[name="interestedIn[]"]').change(function() {
            audienceTypeCheckbox = [];
            $('input[name="interestedIn[]"]:checked').each(function() {
                audienceTypeCheckbox.push(this.value);
            });
        }); 

        // Because there are potentially multiple forms on certain pages, we need to create a forms object that will allow us to track each form indavidually. 
        // Found examples in the Docs:
        // https://docs.solspace.com/craft/freeform/v3/developer/js-plugin.html#adding-callbacks
        
        const forms = document.querySelectorAll('form[data-id]');

        for (const form of forms) {
            const freeform = form.freeform;
            freeform.addOnSuccessfulAjaxSubmit((event, form, response) => {
                dataLayer.push({
                    'event': 'formSubmission',
                    'formType': $(form).attr('id'),
                    'audienceType':selectedPearlAudience,
                    'audienceTypeCheckbox':audienceTypeCheckbox.join(", "),
                    'linkClick':window.location.href
                });
                window.location.href = response.returnUrl;  
            })   
        }



        // Calendly
        const calendlyButtons = document.querySelectorAll('.calendly-button');
        
        if(calendlyButtons !== undefined && calendlyButtons !== null) {
            calendlyButtons.forEach((button) => {

                if (button.getAttribute('data-calendlylink') !== null) {
                    // Add div for calendly widget modal
                    let calendlyContainer = document.createElement('div');
                    let containerId = 'calendly-widget-' + Array.prototype.indexOf.call(calendlyButtons, button);
                    calendlyContainer.setAttribute('id', containerId);
                    calendlyContainer.classList.add('calendly-widget');
                    calendlyContainer.style.display = 'none';
                    button.setAttribute('data-src', '#' + containerId)
                
                    $('body').append(calendlyContainer);
            
                    // Calendly code to insert widget into new div ^
                    Calendly.initInlineWidget({
                        url: button.getAttribute('data-calendlylink'),
                        parentElement: document.getElementById(containerId),
                        prefill: {},
                        utm: {}
                    });
                }
                
            })
        }


});
















